var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M15 2L6.33333 11L2 6.5002","stroke":"#605E5E","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round"}})
}
var staticRenderFns = []

export { render, staticRenderFns }